import { Controller } from '@hotwired/stimulus'

// Держит пункты навигации в одну строку: всё, что перенеслось бы на вторую,
// прячется с конца. Прятать можно только пункты, продублированные в бургер-меню.
export default class NavFitController extends Controller {
  connect() {
    this.boundFit = this.fit.bind(this)
    window.addEventListener('resize', this.boundFit)
    // Poppins догружается после первого рендера и меняет ширину подписей.
    document.fonts.ready.then(this.boundFit)
    this.fit()
    this.element.classList.add('is-fitted')
  }

  disconnect() {
    window.removeEventListener('resize', this.boundFit)
  }

  fit() {
    const items = [...this.element.children]
    items.forEach((item) => (item.hidden = false))

    const [first] = items
    if (!first?.offsetHeight) return

    const firstRowBottom = first.offsetTop + first.offsetHeight
    const firstWrapped = items.findIndex(
      (item) => item.offsetTop >= firstRowBottom
    )
    if (firstWrapped === -1) return

    items.slice(firstWrapped).forEach((item) => (item.hidden = true))
  }
}
